import { CSSProperties } from "react";
import { cn } from "@/core/helpers/cn";
import { BankLogoColored } from "@/domains/bank/components/BankLogoColored";

export function OnboardingFrame({
  children,
  className,
  style,
}: {
  children: React.ReactNode;
  className?: string;
  style?: CSSProperties;
}) {
  return (
    <div
      className={cn(
        "w-[1000px] h-[600px] flex flex-col p-15 m-auto rounded-[1rem] bg-dark-900 shadow-lg bg-cover bg-center font-tt-norms-pro",
        className,
      )}
      style={style}
    >
      <BankLogoColored />

      {children}
    </div>
  );
}
